import type { SVGProps } from 'react';

function IconCheckMarkCircle(props: SVGProps<SVGSVGElement>) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 20 20" fill="none" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 3.08496C13.8191 3.08496 16.9149 6.18091 16.915 10C16.915 13.8192 13.8192 16.915 10 16.915C6.18091 16.9149 3.08496 13.8191 3.08496 10C3.08506 6.18097 6.18097 3.08506 10 3.08496ZM10 18.415C14.6476 18.415 18.415 14.6476 18.415 10C18.4149 5.35249 14.6475 1.58496 10 1.58496C5.35254 1.58506 1.58506 5.35254 1.58496 10C1.58496 14.6475 5.35249 18.4149 10 18.415ZM13.0161 7.88907C12.7232 7.59635 12.2484 7.59624 11.9556 7.88907L9.32374 10.5199L8.04445 9.24063C7.75155 8.94774 7.27679 8.94774 6.9839 9.24063C6.69114 9.53354 6.69105 10.0083 6.9839 10.3012L8.79445 12.1117C8.93507 12.2522 9.12595 12.3315 9.32472 12.3315C9.5235 12.3314 9.7144 12.2523 9.85499 12.1117L13.0161 8.94962C13.309 8.65672 13.309 8.18196 13.0161 7.88907Z"
                fill="currentColor"
            />
        </svg>
    );
}

export default IconCheckMarkCircle;
